import { useAppDispatch, useAppSelector } from "@/app_redux/hooks/root_hook";
import { setOrderModule } from "@/app_redux/reducers/slices/auth/order_management_slice";
import { Switch } from "@headlessui/react";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

const SwitchComponent = () => {
  const [isChecked, setIsChecked] = useState(false);
  const { mappedClinicId } = useAppSelector((state) => state.root.UIStates);

  const dispatch = useAppDispatch();

  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);

  // ✅ read query params
  const queryShift = queryParams.get("shift") ?? "day";
  const processId = queryParams.get("closing_process");
  const isClinicView = queryParams.get("is_clinic");
  const city_id = queryParams.get("city_id");

  const handelChange = () => {
    if (isChecked) {
      !processId && dispatch(setOrderModule("CENTRAL"));
      setIsChecked(false);
      processId &&
        navigate(
          `/app/closing/day-closing?closing_process=${processId}&city_id=${city_id}&clinic_ids=${mappedClinicId}&shift=${queryShift}&t=${Date.now()}`,
        );
    } else {
      !processId && dispatch(setOrderModule("CLINIC"));
      setIsChecked(true);
      processId &&
        navigate(
          `/app/closing/day-closing?closing_process=${processId}&city_id=${city_id}&clinic_ids=${mappedClinicId}&is_clinic=CLINIC&shift=${queryShift}&t=${Date.now()}`,
        );
    }
  };

  useEffect(() => {
    if (isClinicView === "CLINIC") {
      setIsChecked(true);
    }
  }, [isClinicView]);

  return (
    <div className="flex items-center gap-2">
      <p className="whitespace-nowrap">Clinic View</p>
      <Switch
        checked={isChecked}
        onChange={() => {
          handelChange();
        }}
        className={clsx(
          isChecked ? "bg-indigo-600" : "bg-gray-200",
          "relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2",
        )}
      >
        <span
          aria-hidden="true"
          className={clsx(
            isChecked ? "translate-x-5" : "translate-x-0",
            "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out",
          )}
        />
      </Switch>
    </div>
  );
};

export default SwitchComponent;
